import { createAnonymousFirebaseUser } from './createAnonymousFirebaseUser';
import { deleteUser } from './deleteUser';
import { getOrCreateUser } from './getOrCreateUser';
import * as loginActions from './login';
import { logout } from './logout';
import { sendPasswordResetEmail } from './sendPasswordResetEmail';
import { setUser } from './setUser';
import * as signUpActions from './signUp';
import { updateProfile } from './updateProfile';

export const authStoreActions = {
  createAnonymousFirebaseUser,
  ...loginActions,
  logout,
  deleteUser,
  sendPasswordResetEmail,
  setUser,
  getOrCreateUser,
  ...signUpActions,
  updateProfile
};
